import React from 'react';
import { Button, Container } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useMediaQuery from '../../../utils/hooks/mediaQuery.hook';

const CheckoutHeader = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { isMobile } = useMediaQuery();
  const [translate] = useTranslation();
  const { search } = useLocation();

  const redirectToShop = () => {
    const path = `/${slug + search}`;
    navigate(path);
  };

  const iconStyle = isMobile ? 'text-gray' : '';

  return (
    <div className="header checkout-header sticky-top bg-white">
      <Container>
        <div className="d-flex justify-content-center align-items-center py-2 py-md-4 position-relative">
          <div className="d-flex align-items-center position-absolute start-0">
            <Button
              color="link"
              className="d-flex align-items-center text-decoration-none px-3 p-md-0"
              onClick={redirectToShop}
            >
              <FontAwesomeIcon icon={faChevronLeft} className={iconStyle} />
              {' '}
              {!isMobile && (
                <span className="mx-3">
                  {translate('COMMON.BACK_TO_SHOP')}
                </span>
              )}
            </Button>
          </div>
          <div className="text-end">
            <h4 className="checkout-header-title my-auto">
              {translate('COMPONENTS.CHECKOUT_CONTAINER.CHECKOUT')}
            </h4>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default CheckoutHeader;
